import { NgModule } from '@angular/core';

import { DayJsPipe } from './dayjs.pipe';
import { IsInPastPipe } from './is-in-past.pipe';
import { ToDayJsPipe } from './to-dayjs.pipe';

@NgModule({
  declarations: [DayJsPipe, IsInPastPipe, ToDayJsPipe],
  exports: [DayJsPipe, IsInPastPipe, ToDayJsPipe],
})
export class DayjsPipesModule {}
